// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedLevel } from './exportedLevel';
import type { ExportedModuleWorkload } from './exportedModuleWorkload';
import type { ExportedTask } from './exportedTask';
import type { ExportedModuleSourceModuleId } from './exportedModuleSourceModuleId';

/**
 * Module export format
 */
export interface ExportedModule {
  title: string;
  description?: string;
  language?: string;
  levels?: ExportedLevel[];
  workload?: ExportedModuleWorkload;
  tasks?: ExportedTask[];
  author_id: string;
  source_module_id?: ExportedModuleSourceModuleId;
}
